export default "__VITE_ASSET__d69487e9__"